<ng-container *transloco="let t">
    <td-badge color="success" class="ms-2" [matTooltip]="(tooltip$ | async)!">
        <fa-icon class="operators-icon" icon="users"></fa-icon>
    </td-badge>
</ng-container>
